import { config } from "_config";
import { authHeader, customerUid, handleResponse } from "_helpers";

const { ordersApiUrl } = config;

export const credentialsService = {
  getCredentials,
  setCredentials,
};

function getCredentials() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${ordersApiUrl}/customers/${customerUid()}/membership-credentials`;

  return fetch(url, requestOptions).then(handleResponse);
}

function setCredentials(body) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };

  const url = `${ordersApiUrl}/customers/${customerUid()}/membership-credentials`;

  return fetch(url, requestOptions).then(handleResponse);
}
